if (!window.Eurus.loadedScript.has('share-cart.js')) {
  window.Eurus.loadedScript.add('share-cart.js');
  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xCartShare', {
        openShareCart: false,
        cartShareUrl: "",
        shared: false,
        copySuccess: false,
        generateUrl() {
          fetch(Shopify.routes.root + 'cart.js', {
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
          })
          .then(response => response.json())
          .then(response => {
            // HuCare: Gratis-Geschenk nicht mitteilen — es wird beim Empfänger
            // automatisch hinzugefügt (snippets/hucare-gift-add.liquid). Sonst
            // landet es dort als normale, bezahlte Position im Link.
            const items = response.items
              .filter(item => !(item.properties && item.properties._gift))
              .slice()
              .reverse();
            const cartParams = items.map(item => `id:${item.variant_id},q:${item.quantity}`).join('&') + '&share_cart:true';
            this.cartShareUrl = `${window.location.origin}?${cartParams}`;
          });
        },
        copyURL() {
          const cartShareInput = document.getElementById(`x-share-cart-field`);
          if (cartShareInput) {
            navigator.clipboard.writeText(cartShareInput.value).then(
              () => {
                this.copySuccess = true;
                setTimeout(() => {
                  this.copySuccess = false;
                }, 2000);
              },
              () => {
              }
            );
          }
        },
        handleShareCart() {
          const queryString = window.location.search;
          if (queryString.includes("share_cart:true")) {
            const items = queryString
              .substring(1)
              .split('&')
              .reduce((listItem, param) => {
                  if (param.startsWith('id:')) {
                    const [idPart, quantityPart] = param.split(',');
                    const id = parseInt(idPart.slice(3)); 
                    const quantity = parseInt(quantityPart.slice(2));
                    listItem.push({ id, quantity });
                  }
                  return listItem;
              }, []);
            if (items.length > 0) {
              this.addCartItems(items);
            }
          }
        },
        addCartItems(items) {
          // HuCare: früher lief das nur über cart/add.js — das ADDIERT zum bestehenden
          // Warenkorb. Weil die Parameter in der URL stehen blieben, verdoppelte jedes
          // Neuladen des geteilten Links die Mengen.
          // Jetzt zweistufig: erst die geteilten Varianten auf 0 setzen, dann mit den
          // Mengen aus dem Link neu anlegen. Damit ist das Ergebnis immer identisch,
          // egal wie oft der Link geöffnet wird, und es ist unabhängig davon, ob eine
          // Variante in mehreren Zeilen liegt (das passiert, wenn der „Kaufe X, erhalte Y"-
          // Rabatt eine Einheit der Zeile verbraucht und Shopify sie aufteilt).
          // Zusätzlich wird die Query unten entfernt, damit ein Reload gar nichts auslöst.
          const sharedVariants = items.map((item) => item.id);
          const sectionIds = Alpine.store('xCartHelper').getSectionsToRender().map((s) => s.id);

          // Aufräumen muss über den ZEILEN-Schlüssel laufen, nicht über die Varianten-ID:
          // liegt eine Variante in mehreren Zeilen (Rabatt-Aufteilung), erwischt die
          // Varianten-ID nicht alle und es bleibt eine Restmenge stehen.
          fetch(Shopify.routes.root + 'cart.js', {
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
          }).then(response => response.json())
            .then(cart => {
              const reset = (cart.items || []).reduce((acc, line) => {
                if (sharedVariants.indexOf(line.variant_id) !== -1) acc[line.key] = 0;
                return acc;
              }, {});
              if (Object.keys(reset).length === 0) return null;
              return fetch(Shopify.routes.root + "cart/update.js", {
                method: "POST",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: JSON.stringify({ 'updates': reset })
              });
            })
            .then(() => fetch(Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ 'items': items, 'sections': sectionIds })
          })).then(response => response.json())
            .then(response => {
              if (window.history && window.history.replaceState) {
                window.history.replaceState({}, '', window.location.pathname);
              }
              Alpine.store('xCartHelper').reRenderSections(response.sections);
              Alpine.store('xMiniCart').openCart();
              Alpine.store('xCartHelper').currentItemCount = parseInt(document.getElementById('cart-icon-bubble').innerHTML);
              document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
              this.shared = true;
            })
            .catch(error => {
              console.error(error);
            });
        }
      });
    });
  });
}